import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const ordersOperationalDashboardDashboardAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.OrdersV4View,
      Permission.OrdersOperationalConnectPlatformView,
      Permission.OrdersOperationalConnectOrdersView,
    ],
    featureToggles: [FeatureToggle.ordersOperationalDashboard],
  },
  {
    permissions: [
      Permission.OrdersV4View,
      Permission.OrdersOperationalConnectPlatformView,
      Permission.OrdersOperationalConnectOrdersView,
    ],
    warehouseFeatureToggles: [FeatureToggle.ordersOperationalDashboard],
  },
]
